import styled from 'styled-components';

import * as fonts from 'view/styles/fonts';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const requestCreateFieldErrorColor = token('color.text.danger', colors.R500);
const anonymousEmailSignupWarningTextColor = token('color.text.subtlest', colors.N200);
interface SignupMessageProps {
    isError?: boolean;
}

// eslint-disable-next-line rulesdir/no-styled-export
export const SignupMessage = styled.span<SignupMessageProps>`
    ${fonts.xsmall};
    color: ${(props) => (props.isError ? requestCreateFieldErrorColor : anonymousEmailSignupWarningTextColor)};
    font-weight: 500;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Wrapper = styled.div`
    display: flex;
    margin-top: ${token('space.050', '4px')};
`;
